import { ProductKind } from 'constants/product'

export const STRIPE_PRIMARY_PRODUCT_KINDS = new Set([
  ProductKind.SEPA_DIRECT_DEBIT,
  ProductKind.CARD_PAYMENT
])